import { inject, ref } from "vue";
import { useRouter } from "vue-router";
import Toast from "@/plugins/Toast";
import { ToastType } from "@/types/toast";
import { useAuthStore } from "@/store/auth.store";
import { Account } from "@/models/Account";
import AccountsRepository from "@/repositories/AccountsRepository";
import { AxiosResponse } from "axios";
import AccountsDialogViewModel from "../dialogs/AccountsDialogViewModel";

export default class ProductsViewModel {
  public breadcrumbs = [
    {
      title: "Dashboard",
      disabled: false,
      href: "/app/home",
    },
    {
      title: "Productos o Servicios",
      disabled: true,
      href: "",
    },
  ];

  public toast: Toast;
  private router = useRouter();
  public accountsDialogRef: any;
  public simulatorDialogRef: any;
  private accounts = ref<Account[]>([]);
  public loadingAccounts = ref<boolean>(false);
  private authStore = useAuthStore();
  private appName = process.env.VUE_APP_APP_NAME || "Cooperativa";
  private webpage = process.env.VUE_APP_WEBPAGE || "https://example.com";
  private whatsapp = process.env.VUE_APP_WHATSAPP || "999999999"; // Número de WhatsApp de la cooperativa

  public services = ref<Service[]>([
    {
      title: "Solicitar Crédito",
      description: "Solicita un crédito de manera rápida y segura.",
      icon: "mdi-wallet",
      action: "message",
      label: "Solicitar",
    },
    {
      title: "Aperturar Ahorros",
      description: "Crea una cuenta de ahorros con beneficios exclusivos.",
      icon: "mdi-piggy-bank",
      action: "message",
      label: "Solicitar",
    },
    {
      title: "Simulador de Crédito",
      description: "Calcula tus cuotas con nuestro simulador.",
      icon: "mdi-calculator",
      action: "dialog",
      label: "Abrir simulador",
      dialog: "creditSimulator",
    },
    {
      title: "Canales de Pago",
      description: "Consulta los canales de pago disponibles.",
      icon: "mdi-bank",
      action: "dialog",
      label: "Ver canales de pago",
      dialog: "paymentChannels",
    },
    {
      title: "Nuestra Web",
      description: "Visita nuestro sitio web oficial.",
      icon: "mdi-web",
      action: "external",
      label: "Visitar Web",
    },
    {
      title: "WhatsApp Soporte",
      description: "Contacta soporte técnico vía WhatsApp.",
      icon: "mdi-whatsapp",
      action: "message",
      label: "Contactar con soporte",
    },
  ]);

  constructor(accountsDialogRef: any, simulatorDialogRef: any) {
    this.accountsDialogRef = accountsDialogRef;
    this.simulatorDialogRef = simulatorDialogRef;
    this.toast = inject("toast") as Toast;
    this.loadAccounts();
  }

  loadAccounts = async () => {
    try {
      this.loadingAccounts.value = true;
      const authBasic = btoa(
        `${this.authStore.getLogin}:${this.authStore.getDecryptedPassword}`
      );
      const response: AxiosResponse = await AccountsRepository.accounts(
        authBasic
      );

      const { data } = response.data;
      this.accounts.value = data;
      this.loadingAccounts.value = false;
    } catch (error) {
      this.toast.showToast(
        "Error al cargar las transacciones. Intente nuevamente.",
        ToastType.Error
      );
      this.loadingAccounts.value = false;
    }
  };
  /**
   * Handle service card click based on action type.
   */
  async handleServiceClick(service: Service) {
    const userData = await this.authStore.getUserData;

    let message = ""; // Variable para construir el mensaje

    switch (service.title) {
      case "Solicitar Crédito":
        message = `¡Hola equipo de la ${this.appName}! Soy socio y me llamo ${userData?.nom}. Estoy interesado en abrir una cuenta de CRÉDITO. Mi documento de identidad es: ${userData?.dni}. ¿Podrían indicarme los pasos a seguir? ¡Gracias de antemano por su ayuda!`;
        //this.toast.showToast(message, ToastType.Success);
        window.open(
          `https://wa.me/51${this.whatsapp}?text=${message}`,
          "_blank"
        );
        break;

      case "Aperturar Ahorros":
        message = `¡Hola equipo de la ${this.appName}! Soy socio y me llamo ${userData?.nom}. Estoy interesado en abrir una cuenta de AHORROS. Mi documento de identidad es: ${userData?.dni}. ¿Cuáles son los pasos que debo seguir para realizar esta solicitud? ¡Gracias por su atención!`;
        //this.toast.showToast(message, ToastType.Success);
        window.open(
          `https://wa.me/51${this.whatsapp}?text=${message}`,
          "_blank"
        );
        break;

      case "Simulador de Crédito":
        if (service.dialog) {
          this.simulatorDialogRef.value?.openDialog();
        }
        break;

      case "Canales de Pago":
        if (service.dialog) {
          this.accountsDialogRef.value?.openDialog(this.accounts.value);
        }
        break;

      case "Nuestra Web":
        window.open(this.webpage, "_blank");
        break;

      case "WhatsApp Soporte":
        message = `Hola equipo de ${this.appName}, mi nombre es ${userData?.nom}, vengo desde la aplicación móvil y necesito soporte.`;
        //this.toast.showToast(message, ToastType.Success);
        window.open(
          `https://wa.me/51${this.whatsapp}?text=${message}`,
          "_blank"
        );
        break;

      default:
        console.warn("No action defined for this service.");
    }
  }
}
